"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  "use strict";

  var moduleName = "course.selectionElearnings";
  var componentName = "selectElearnings";

  var bindings = {
    selectedIds: "=",
    courseType: "<"
  };

  var templateUrl = "app/pages/courses/selectionElearnings/selectionElearnings.html";

  var Controller = function () {
    /** @ngInject */
    function Controller($scope, $timeout, $rootScope, ElearningTemplatesService, ElearningCampaignsService, CustomersService, AgGridService) {
      _classCallCheck(this, Controller);

      this.$scope = $scope;
      this.$timeout = $timeout;
      this.$rootScope = $rootScope;
      this.ElearningTemplatesService = ElearningTemplatesService;
      this.ElearningCampaignsService = ElearningCampaignsService;
      this.CustomersService = CustomersService;
      this.AgGridService = AgGridService;

      this.columnDefs = [this.AgGridService.text("name", "Nom"), AgGridService.button("btDelete", "Retirer", this.delete, this, {
        width: 90
      })];
    }

    _createClass(Controller, [{
      key: "loadElearningsArray",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var customer, vehicleTypes, authorizedVehicleTypes, templateType, campaigns, sentTemplateIds, templates;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.CustomersService.getById(this.$rootScope.$selectedCustomerId);

                case 2:
                  customer = _context.sent;
                  vehicleTypes = customer.comFleetTypes || [];
                  authorizedVehicleTypes = ["TOUS", "AUTRES"];

                  if (vehicleTypes.includes("VUL")) {
                    authorizedVehicleTypes.push("VL");
                  }
                  if (vehicleTypes.includes("VU")) {
                    authorizedVehicleTypes.push("VUL");
                  }
                  if (vehicleTypes.includes("PL")) {
                    authorizedVehicleTypes.push("PL");
                    authorizedVehicleTypes.push("GL");
                  }
                  if (vehicleTypes.includes("BUS")) {
                    authorizedVehicleTypes.push("CAR");
                    authorizedVehicleTypes.push("GL");
                  }

                  templateType = this.courseType === "C8" ? "long" : this.courseType === "C11" ? "challenge" : "short";

                  // Restriction aux templates envoyés pour éviter d'afficher des templates qui ne seraient pas encore disponibles pour le client

                  _context.next = 12;
                  return this.ElearningCampaignsService.find({
                    filter: {
                      where: {
                        customerId: "$" + customer._id,
                        type: templateType,
                        lastGenerationDate: { $exists: true, $ne: null },
                        // Limité aux campagnes des 12 derniers mois
                        startDate: {
                          $lte: new Date(),
                          $gte: new Date(Date.now() - 365 * 24 * 60 * 60 * 1000)
                        }
                      },
                      fields: { _id: true, elearningTemplateIds: true }
                    }
                  });

                case 12:
                  campaigns = _context.sent;
                  sentTemplateIds = new Set(campaigns.flatMap(function (c) {
                    return c.elearningTemplateIds || [];
                  }));
                  _context.next = 16;
                  return this.ElearningTemplatesService.find({
                    filter: {
                      where: {
                        type: templateType,
                        _id: { $in: Array.from(sentTemplateIds) },
                        vehicleType: {
                          $exists: true,
                          $ne: null,
                          $nin: ["NPU"]
                        }
                      },
                      fields: { _id: true, name: true, vehicleType: true, type: true }
                    }
                  });

                case 16:
                  templates = _context.sent;


                  this.elearningArray = templates.map(function (t) {
                    return {
                      name: "[" + t.vehicleType + "] - " + (t.name || t._id),
                      value: "$" + t._id
                    };
                  }).sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                  });

                  this.$timeout(function () {});

                case 19:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function loadElearningsArray() {
          return _ref.apply(this, arguments);
        }

        return loadElearningsArray;
      }()
    }, {
      key: "envChanged",
      value: function envChanged() {
        var index = this.selectedIds.indexOf(this.selectedElearning.value);

        if (index === -1) {
          this.selectedIds.push(this.selectedElearning.value);
          this.updateTable();
        }
      }
    }, {
      key: "delete",
      value: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(row, ctx) {
          var deleteElement, index;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return swal({
                    title: "Voulez-vous retirer \"" + row.name + "\" ?",
                    icon: "warning",
                    dangerMode: true,
                    buttons: ["Annuler", "Valider"]
                  });

                case 2:
                  deleteElement = _context2.sent;


                  if (deleteElement) {
                    index = ctx.selectedIds.indexOf(row.value);


                    if (index > -1) {
                      ctx.selectedIds.splice(index, 1);
                      ctx.updateTable();
                    }
                  }

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function _delete(_x, _x2) {
          return _ref2.apply(this, arguments);
        }

        return _delete;
      }()
    }, {
      key: "updateTable",
      value: function updateTable() {
        var _this = this;

        if (!this.elearningArray) {
          return;
        }

        if (this.selectedIds) {
          var selectedElearnings = [];

          var _loop = function _loop(_i) {
            var id = _this.selectedIds[_i];
            var item = _this.elearningArray.find(function (e) {
              return e.value === id;
            });

            if (item) {
              selectedElearnings.push({
                name: item.name,
                value: item.value,
                btDelete: {
                  text: '<i class="fa fa-eraser"></i> Retirer',
                  color: "custom"
                }
              });
              _i++;
            } else {
              console.log("no elearning for " + id);
              _this.selectedIds.splice(_i, 1);
            }
            i = _i;
          };

          for (var i = 0; i < this.selectedIds.length;) {
            _loop(i);
          }

          this.rawData = selectedElearnings;

          this.$timeout(function () {
            _this.needToBeUpdate = true;
          });
        } else {
          this.selectedIds = [];
        }
      }
    }, {
      key: "$onInit",
      value: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
          var _this2 = this;

          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return this.loadElearningsArray();

                case 2:

                  this.$scope.$watch(function () {
                    return _this2.selectedIds;
                  }, function () {
                    _this2.updateTable();
                  });

                  this.$scope.$watch(function () {
                    return _this2.courseType;
                  }, function () {
                    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(newVal, oldVal) {
                      return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              if (!(newVal !== oldVal)) {
                                _context3.next = 6;
                                break;
                              }

                              _this2.selectedIds = [];
                              _this2.selectedElearning = null;
                              _context3.next = 5;
                              return _this2.loadElearningsArray();

                            case 5:
                              _this2.updateTable();

                            case 6:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3, _this2);
                    }));

                    return function (_x3, _x4) {
                      return _ref4.apply(this, arguments);
                    };
                  }());

                case 4:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function $onInit() {
          return _ref3.apply(this, arguments);
        }

        return $onInit;
      }()
    }]);

    return Controller;
  }();

  angular.module(moduleName).component(componentName, {
    templateUrl: templateUrl,
    bindings: bindings,
    controller: Controller
  });
})();